import React from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { PUBLICA_URL } from 'constants/index';
import MessagesScreen from 'components/messagesScreen/messagesScreen';

const VerificationInProcessView = () => {
    const messagesScreenAction = () => {
        window.location.href = PUBLICA_URL;
    };
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-success-blue"
                title={formatText('messagesScreen-identityVerificationInProcessTitle')}
                subtitle=""
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={messagesScreenAction}
            >
                <FormattedText value="messagesScreen-identityVerificationInProcessContent" />
            </MessagesScreen>
        </div>
    );
};

export default VerificationInProcessView;
